import React from 'react';
import { Box, Button } from '@mui/material';
import { PostAdd, Add } from '@mui/icons-material';

interface ActionButtonsProps {
  handleCreatePost: () => void;
  handleCreateCommunity: () => void;
  isDark: boolean;
  goldColor: string;
  deepGreen: string;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  handleCreatePost,
  handleCreateCommunity,
  isDark,
  goldColor,
  deepGreen
}) => {
  return (
    <Box sx={{ 
      mb: 3,
      width: '100%'
    }}>
      {/* Stacked rather than side by side: the two labels need roughly 325px
          together, which is wider than this column at every desktop breakpoint
          below xl, and side by side made them wrap onto two lines. */}
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        alignItems: 'stretch',
        width: '100%'
      }}>
        {/* Create Post Button */}
        <Button
          variant="contained"
          startIcon={<PostAdd sx={{ fontSize: '1rem' }} />}
          onClick={handleCreatePost}
          sx={{
            width: '100%',
            whiteSpace: 'nowrap',
            background: isDark
              ? `linear-gradient(135deg, ${goldColor} 0%, rgba(196, 182, 111, 0.9) 100%)`
              : 'linear-gradient(135deg, #051814 0%, #0F3B2E 100%)',
            color: isDark ? deepGreen : goldColor,
            borderRadius: '50px',
            fontWeight: 700,
            textTransform: 'none',
            boxShadow: `0 4px 12px rgba(${isDark ? '196, 182, 111' : '5, 24, 20'}, 0.2)`,
            transition: 'all 0.2s ease',
            px: 2,
            py: 1,
            fontSize: '0.875rem',
            height: '44px',
            minWidth: 0,
            '&:hover': {
              transform: 'translateY(-2px)',
              boxShadow: `0 6px 16px rgba(${isDark ? '196, 182, 111' : '5, 24, 20'}, 0.3)`,
              background: isDark 
                ? `linear-gradient(135deg, rgba(196, 182, 111, 0.95) 0%, rgba(196, 182, 111, 0.85) 100%)`
                : 'linear-gradient(135deg, #051814 0%, #0F3B2E 100%)',
            },
            '& .MuiButton-startIcon': {
              marginRight: '6px',
              marginLeft: 0
            }
          }}
        >
          Create Post
        </Button>

        {/* Create Community Button */}
        <Button
          variant="outlined"
          startIcon={<Add sx={{ fontSize: '1rem' }} />}
          onClick={handleCreateCommunity}
          sx={{
            width: '100%',
            whiteSpace: 'nowrap',
            borderColor: goldColor,
            color: goldColor,
            borderRadius: '50px',
            fontWeight: 700,
            textTransform: 'none',
            transition: 'all 0.2s ease',
            px: 2,
            py: 1,
            fontSize: '0.875rem',
            height: '44px',
            minWidth: 0,
            borderWidth: '2px',
            '&:hover': {
              borderColor: goldColor,
              backgroundColor: isDark
                ? 'rgba(196, 182, 111, 0.1)'
                : 'rgba(196, 182, 111, 0.05)',
              transform: 'translateY(-2px)',
              boxShadow: `0 4px 12px rgba(196, 182, 111, 0.2)`,
            },
            '& .MuiButton-startIcon': {
              marginRight: '6px',
              marginLeft: 0
            }
          }}
        >
          Create Community
        </Button>
      </Box>
    </Box>
  );
};

export default ActionButtons;